<template>
    <div id="top-bar" class="hidden-md-down">
        <div class="container">
            <div class="row">
                <div class="col-md-9 col-12">
                    <ul class="top-bar-info" v-if="infos != null">
                        <li><i class="fas fa-phone"></i> {{ infos[2].value }}</li>
                        <li><i class="fas fa-map-marker-alt"></i> {{ infos[1].value }}</li>
                        <li><i class="fa fa-envelope"></i> {{ infos[0].value }}</li>
                    </ul>
                </div>
                <div class="col-md-3 col-12">
                    <ul class="social-icons hidden-sm">
                        <li><a href="#"><i class="fab fa-facebook"></i></a></li>
                        <li><a href="#"><i class="fab fa-twitter"></i></a></li>
                        <li><a href="#"><i class="fab fa-linkedin"></i></a></li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { BASE_URL, API_PREFIX, API_VERSION } from '@/config/urls'
export default {
  name: 'TopBar',
  data () {
    return {
      infos: null
    }
  },
  mounted () {
    this.getInfos()
  },
  methods: {
    getInfos () {
      return new Promise((resolve, reject) => {
        this.$http.get(BASE_URL + API_PREFIX + API_VERSION + '/infos')
          .then((response) => {
            this.infos = response.data
            resolve(this.infos)
          })
          .catch((error) => {
            console.log(error)
            reject(error)
          })
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/common/TopBar.vue